/* eslint-disable */
// @ts-nocheck
import React, { useState, useRef, useEffect } from 'react';
import { css } from '@emotion/react';
import { Input } from 'ALIASED-antd';
import Autosuggest from 'react-autosuggest';
import _ from 'lodash';
import useApi from '../hooks/useApi';
import styled from '@emotion/styled';
import { sanitiseValueFromAngleBrackets } from '../utils';
import { useTranslation } from 'react-i18next';

const AutocompleteWrapper = styled.div`
  && .react-autosuggest__input {
    padding: 0 12px !important;
    max-height: 32px;
    font-family: 'Montserrat', sans-serif;
    font-variant: tabular-nums;
    font-size: 14px;
  }
`;

const StyledInput = styled(Input)`
  && .ant-input-disabled {
    color: var(--bs-body-color);
  }
`;

const PostcodeAutocomplete = ({
  placeholder = 'Find...',
  onSelect,
  valueEx = '',
  useAntd = false,
  disabled = false,
  onManualChange = () => {}
}) => {
  const { t } = useTranslation('common');
  const { Api, toasted } = useApi();
  const [apiSuggestions, setApiSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [value, setValue] = useState(valueEx === null ? '' : valueEx);
  const refInput = useRef();
  const [lastValue, setLastValue] = useState('');
  const [, rerender] = useState(0);

  // When suggestion is clicked, Autosuggest needs to populate the input
  // based on the clicked suggestion. Teach Autosuggest how to calculate the
  // input value for every given suggestion.
  const getSuggestionValue = (suggestion) => suggestion.value;

  const onChange = (event, { newValue }) => {
    const sanitisedValue = sanitiseValueFromAngleBrackets(newValue);
    setValue(sanitisedValue);
    onManualChange(sanitisedValue);
  };

  useEffect(() => {
    setValue(valueEx);
  }, [valueEx]);
  const onSuggestionsFetchRequested = ({ value }) => {
    loadSuggestions(value);
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onSuggestionSelected = (event, { suggestion }) => {
    if (onSelect) {
      onSelect(suggestion);
      rerender((r) => r + 1);
      if (useAntd) setValue(suggestion.postcode);
    }
  };

  const loadSuggestions = (value) => { };
  const findPostcode = async (postcode_name) => {
    try {
      const res = await Api.file.postcode(postcode_name);
      console.debug('POSTCODE DATA', res);

      const transform_array = res.data.result.map((data2) => {
        const t1 = data2.line_1;
        const t2 = data2.line_2;
        const t3 = data2.line_3;
        const address = [t1, t2, t3].filter(Boolean).join(', ');
        return {
          value: address,
          line1: t1,
          line2: t2,
          line3: t3,
          region: data2.county,
          town: _.startCase(_.toLower(data2.post_town)),
          postcode: data2.postcode.toUpperCase(),
          country: data2.country,
          isAddressFound: true
        };
      });

      setApiSuggestions(transform_array);
      setSuggestions(transform_array);
    } catch (e) {
      const transform_array = [
        {
          value: '',
          lineAddress: '',
          region: '',
          country: '',
          town: '',
          postcode: postcode_name,
          isAddressFound: false
        }
      ];
      try {
        const status = e.response.status;
        if (status === 404) {
          transform_array[0].value = 'No address found';
        } else if (status === 402) {
          //402 == no lookups remaining -> TOP UP API
          transform_array[0].value = 'Unexpected error occurred';
        } else {
          toasted(e);
        }
        setApiSuggestions(transform_array);
        setSuggestions(transform_array);
      } catch (er) {
        transform_array[0].value = 'Not found';
        setApiSuggestions(transform_array);
        setSuggestions(transform_array);
      }
    }
  };

  const onSearchClicked = () => {
    if (lastValue !== value) {
      setLastValue(value);
      findPostcode(value);
    } else {
      setSuggestions([]);
      setSuggestions(_.cloneDeep(apiSuggestions));
    }

    refInput.current?.focus();
  };

  // custom input search
  const renderInputComponent = (inputProps) => {
    const { key: reactKey, ...domInputProps } = inputProps ?? {}

    return (
      <div className="inputContainer">
        <input
          key={reactKey}
          {...domInputProps}
          ref={refInput}
          disabled={disabled}
          style={disabled ? { backgroundColor: 'var(--bs-secondary-bg)', color: 'var(--bs-body-color)' } : {}}
        />
        <span className="search_btn" onClick={onSearchClicked}>
          {t('Search')}
        </span>
      </div>
    )
  };

  // antd input search
  const renderInputComponentAntd = (inputProps) => (
    <StyledInput
      {...inputProps}
      ref={refInput}
      onPressEnter={onSearchClicked}
      style={
        disabled
          ? {
            backgroundColor: 'var(--bs-secondary-bg)',
            padding: '0px',
            borderBottom: '1px solid black',
            borderRadius: '0px'
          }
          : {}
      }
      disabled={disabled}
      className="autoSuggestInput"
      suffix={
        <span
          className="search_btn"
          style={{ lineHeight: '10px', padding: '0px 12px 0px 0px', cursor: 'pointer', textDecoration: 'none' }}
          onClick={onSearchClicked}
        >
          {t('Search')}
        </span>
      }
    />
  );

  // custom item rendering
  const renderSuggestion = (suggestion) => (
    <div>
      <div style={styles.renderSuggestion}>{suggestion.value}</div>
    </div>
  );

  // Autosuggest will pass through all these props to the input.
  const inputProps = {
    placeholder,
    value: value || '',
    onChange
  };

  const AutoSuggestComp = (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      onSuggestionSelected={onSuggestionSelected}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      focusInputOnSuggestionClick={false}
      inputProps={inputProps}
      renderInputComponent={useAntd ? renderInputComponentAntd : renderInputComponent}
    />
  );

  return useAntd ? <AutocompleteWrapper>{AutoSuggestComp}</AutocompleteWrapper> : AutoSuggestComp;
};

export { PostcodeAutocomplete };

const styles = {
  renderSuggestion: { fontSize: '12px', color: '#000' }
};
